import * as React from 'react'
import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore'
import { getRoomParticipantSubtitleItems } from '../selectors'
import styles from './RoomParticipantsSubtitle.module.css'

export interface RoomParticipantsSubtitleProps {
  roomId: string
}

const STATUS_CLASS_NAMES: Record<'unchanged' | 'added' | 'removed', string | undefined> = {
  unchanged: undefined,
  added: styles.addedParticipant,
  removed: styles.removedParticipant,
}

export function RoomParticipantsSubtitle({ roomId }: RoomParticipantsSubtitleProps) {
  const items = useGroupResponsibleStore(state => getRoomParticipantSubtitleItems(state, roomId))

  if (items.length === 0) {
    return <>-</>
  }

  return (
    <>
      {items.map((item, index) => (
        <React.Fragment key={`${item.status}-${item.id}`}>
          {index > 0 && ', '}
          <span className={STATUS_CLASS_NAMES[item.status]}>
            {item.name}
          </span>
        </React.Fragment>
      ))}
    </>
  )
}
